import { render, staticRenderFns } from "./test-analysis.vue?vue&type=template&id=0a28b7ce&scoped=true"
import script from "./test-analysis.vue?vue&type=script&lang=js"
export * from "./test-analysis.vue?vue&type=script&lang=js"
import style0 from "./test-analysis.vue?vue&type=style&index=0&id=0a28b7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a28b7ce",
  null
  
)

export default component.exports